import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';

export const IS_C1_SEARCH_PARAM = 'isc1';

export function useIsC1Integrated() {
    const searchParams = useSearchParams();
    const [isC1Integrated, setIsC1Integrated] = useState<boolean | null>(() => {
        if(searchParams?.get(IS_C1_SEARCH_PARAM) === 'true') {
            return true;
        } else {
            return null; // Check whether we're loaded in an iframe
        }
    });

    useEffect(() => {
        if(isC1Integrated !== null) {
            return;
        }
        if(window.self !== window.top) {
            const url = new URL(window.location.href);
            if(! url.searchParams.get(IS_C1_SEARCH_PARAM)) {
                url.searchParams.set(IS_C1_SEARCH_PARAM, 'true');
                window.location.replace(url.toString());
            }

            setIsC1Integrated(true);
        } else {
            setIsC1Integrated(false);
        }
    }, [isC1Integrated, setIsC1Integrated]);

    return isC1Integrated;
}